module.exports = __webpack_public_path__ + "static/media/underConstruction.e5796cfc.png";